export default __webpack_public_path__ + "static/media/LolChampionGalleryImg_2.19b0b353.png";